import type { User } from '../types'
import { hasFinancistAccess } from './roleFinancialAccess'

/** Kdo vidí dnešní narozeniny v Můj kabinet. */
export function canSeeCabinetBirthdays(user: Pick<User, 'role' | 'admin_type'> | null | undefined): boolean {
  if (!user?.role) return false
  if (user.role === 'director') return true
  if (user.role === 'personalista') return true
  if (hasFinancistAccess(user)) return true
  if (user.role === 'admin' && (user.admin_type === 'spravce_it' || user.admin_type === 'spravce_budov')) {
    return true
  }
  return false
}
